import React, { useState, useEffect } from "react";
import { FaUser, FaBars, FaTimes } from "react-icons/fa";
import logo from "../images/buzzy-logo.png";
import { Link } from "react-router-dom";

const VisitorsHeader = ({ isHome }) => {
  const [nav, setNav] = useState(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  const handleClick = () => setNav(!nav);
  const handleClose = () => setNav(false);

  useEffect(() => {
    const handleResize = () => {
      const newWindowWidth = window.innerWidth;
      setWindowWidth(newWindowWidth);
      if (newWindowWidth <= 768) {
        setNav(false);
      }
    };

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const links = [
    { to: "/", label: "Home" },
    { to: "/marketplace", label: "Marketplace" },
    { to: "/homeevent", label: "Events" },
    { to: "/homevote", label: "Vote" },
    { to: "/jobs", label: "Jobs" },
    { to: "/news", label: "News" },
    { to: "/support", label: "Support" },
  ];

  return (
    <div className="w-full h-[10vh] top-0 bg-white fixed z-50 px-3 lg:px-0">
      <div className="lg:w-[85%] h-full mx-auto flex justify-between items-center">
        <div className="flex items-center">
          <img src={logo} alt="Logo" className="w-15 h-16" />
        </div>

        {windowWidth > 768 && (
          <div className="flex flex-col items-center md:flex-row md:space-x-8">
            {links.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className="text-[20] text-[#000] font-medium focus:outline-none cursor-pointer hover:text-[#405AC6] transition duration-300"
              >
                {link.label}
              </Link>
            ))}
          </div>
        )}

        <div className="hidden md:flex items-center space-x-4 sm:hidden">
          <Link
            to={isHome ? "/login" : "/register"}
            onClick={() => localStorage.removeItem("signupStep")}
          >
            <button
              className={` ${
                isHome
                  ? "text-[#405AC6] font-medium px-5 py-2 cursor-pointer text-[20] border border-[#405AC6] hover:text-[#213481] transition duration-300 rounded-lg"
                  : "text-[20] text-black font-normal px-2 py-1 cursor-pointer"
              } `}
            >
              {isHome ? "Login" : "Register"}
            </button>
          </Link>
          <Link to={isHome ? "/register" : "/login"}>
            <button
              className={`${
                isHome
                  ? "bg-[#405AC6] text-[20] font-medium flex justify-evenly cursor-pointer hover:bg-blue-800 text-white px-4 py-2 rounded-lg transition duration-300"
                  : " text-white px-4 py-2 rounded-lg bg-[#405AC6] text-[20] font-medium flex justify-evenly cursor-pointer transition duration-300"
              } `}
            >
              {isHome !== true && (
                <FaUser color="white" className="text-base mr-2" />
              )}

              {isHome ? "Get Started" : "Login "}
            </button>
          </Link>
        </div>

        <div className="md:hidden" onClick={handleClick}>
          {!nav ? (
            <FaBars className="w-8 h-6" />
          ) : (
            <FaTimes className="w-8 h-6" />
          )}
        </div>
      </div>

      <div
        className={
          !nav
            ? "hidden"
            : "absolute bg-white w-full h-screen drop-shadow-sm px-8 py-5"
        }
      >
        <ul>
          {links.map(({ to, label }) => (
            <li
              key={to}
              className="border-b-2 border-zinc-100 w-full text-center py-5 cursor-pointer hover:text-[#213481] transition duration-300"
            >
              <Link
                onClick={handleClose}
                to={to}
                smooth={true}
                offset={-50}
                duration={500}
              >
                {label}
              </Link>
            </li>
          ))}

          <Link
            to="/register"
            onClick={() => localStorage.removeItem("signupStep")}
          >
            <button className="text-black px-4 py-2 cursor-pointer text-[20] hover:text-[#213481] transition duration-300 font-normal rounded border border-[#213481] text-center w-full my-3">
              Register
            </button>
          </Link>

          {/* Login Button */}
          <Link to="/login">
            <button className="login-bg flex justify-evenly cursor-pointer hover:bg-blue-800 text-white px-4 py-2 rounded w-full my-3">
              Login
            </button>
          </Link>
        </ul>
      </div>
    </div>
  );
};

export default VisitorsHeader;
